import { graphql } from '../../../graphql/generated';

export const SPECIAL_RATES_QUERY = graphql(`
  query SpecialRates($labId: ID!) {
    labSpecialRates(labId: $labId) {
      id
      name
      shortName
      code
    }
  }
`);
